import { BrandIntelligence } from "@/schema/brand-intelligence";

import { mBrandIntelligenceLenovo } from "@/mock/lenovo";
import { mBrandIntelligenceOutdoorAmerica } from "@/mock/outdoor-america";
import { mBrandIntelligenceForaFinancial } from "@/mock/fora-financial";
import { mBrandIntelligenceAparnaConstructions } from "@/mock/aparna-constructions";
import { mBrandIntelligenceNaturalsSalon } from "@/mock/naturals-salon";
import { mBrandIntelligenceSwitchMobility } from "@/mock/switch-mobility";
import { mBrandIntelligenceLitemed } from "@/mock/litemed";
import { mBrandIntelligenceKaidoo } from "@/mock/kaidoo";
import { mBrandIntelligenceProteinPantry } from "@/mock/protein-pantry";
import { mBrandIntelligenceMyWonder } from "@/mock/my-wonder";
import { mBrandIntelligenceStyleUnion } from "@/mock/style-union";
import { mBrandIntelligenceRubyOrganics } from "@/mock/ruby-organics";
import { mBrandIntelligenceWakefit } from "@/mock/wakefit";

export const mEnterpriseBrandIntelligence: Record<string, BrandIntelligence> = {
  "lenovo@zocket.com": mBrandIntelligenceLenovo,
  "meghna@bigboost.agency": mBrandIntelligenceOutdoorAmerica,
  "ramya.vardhini@bigboost.agency": mBrandIntelligenceForaFinancial,
  "aparnaconstructions@zocket.com": mBrandIntelligenceAparnaConstructions,
  "naturals@zocket.com": mBrandIntelligenceNaturalsSalon,
  "switchmobility@zocket.com": mBrandIntelligenceSwitchMobility,
  "curapod@zocket.com": mBrandIntelligenceLitemed,
  "kaidookid@zocket.com": mBrandIntelligenceKaidoo,
  "proteinpantry@zocket.com": mBrandIntelligenceProteinPantry,
  "mywonder@zocket.com": mBrandIntelligenceMyWonder,
  "styleunion@zocket.com": mBrandIntelligenceStyleUnion,
  "rubysorganics@zocket.com": mBrandIntelligenceRubyOrganics,
  "wakefit@zocket.com": mBrandIntelligenceWakefit,

  "aditi@zocket.com": mBrandIntelligenceWakefit,
  "debojit@zocket.com": mBrandIntelligenceLitemed,
};
